import React from 'react'
import star from '../../../../public/assets/img/WomansCategory/star.png'
import MoreOptionIcon from '../../../../public/assets/icon/moreOptionIconsc.svg'
import { fetchMobileModalData } from 'src/store/slices/mobileModalSlice'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'src/store/store'

export default function ProductListView({ products, color, stateForWidth }) {
  
  const stopMovie = (e) => {
    e.target.pause()
  }

  const playMovie = (e) => {
    e.target.play()
  }

  const fetchMobileModal = useSelector((state: any) => state?.manageMobileModal?.data)
  const dispatch = useAppDispatch()

  return (
    <>
      <div className="row findYourStyle_mobile-view-list-details-alignment" style={{ backgroundColor: color }}>
        {products?.map((product, index) => {
          return (
            <div className="fondYourStyle_mobile-view-list-box" key={index}>
              <div className="fondYourStyle_img-alignment">
                {(product?.images && product?.images[0]?.src?.includes('mp4')) ||
                (product?.images && product?.images[0]?.src?.includes('mov')) ? (
                  <video loop autoPlay={true} onMouseOver={playMovie} onMouseOut={stopMovie} poster={''}>
                    <source src={product?.images && product?.images[0]?.src} type="video/mp4" />
                  </video>
                ) : (
                  <img src={product?.images && product?.images[0]?.src} />
                )}
              </div>
              <div className="fondYourStyle_listView-details-alignment">
                <div>
                  <h4>{product?.title?.length > 30 ? product?.title.substring(0, 30) + '...' : product?.title}</h4>
                  <div className="listView-details_product-child-details-alignment">
                    <div className="listView-details_product-proce-discount-alignment">
                      <p>$ {product?.dis_price ? product?.dis_price : product?.inventoryPrice?.price}</p>
                      <span>
                        {product?.dis_listPrice || product?.inventoryPrice?.listPrice ? '$' : ''}
                        {product?.dis_listPrice ? product?.dis_listPrice : product?.inventoryPrice?.listPrice}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="listView-details_findYourStyle-list-details-alignment">
                  <div className="mobile-men-sub-category-list-card_utils">
                    <div className="mobile-men-sub-category-list-box">
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.09102 11.5061L7.09057 11.5061C7.06785 11.5279 7.04378 11.5482 7.01851 11.5669L4.9283 13.1154C4.70086 13.2839 4.39793 13.31 4.14503 13.1829C3.89212 13.0558 3.73232 12.7971 3.73184 12.514L3.73013 11.5061H2.72877C1.941 11.5061 1.2496 10.8855 1.2496 10.0561V4.7C1.2496 3.87062 1.941 3.25 2.72877 3.25H11.4788C12.2666 3.25 12.958 3.87062 12.958 4.7V10.0561C12.958 10.8855 12.2666 11.5061 11.4788 11.5061H7.09102Z"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {product?.like_count || 0}
                    </div>
                    <div className="mobile-men-sub-category-list-box">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M6.99967 3.39334L5.92439 2.28777L5.79518 2.15492L6.86677 1.11268L5.79518 2.15492C4.94587 1.28169 3.5797 1.28169 2.73039 2.15492C1.86721 3.04241 1.86721 4.49157 2.73039 5.37906L6.99967 9.76859L11.269 5.37906C12.1321 4.49157 12.1321 3.04241 11.269 2.15492C10.4197 1.28169 9.05348 1.28169 8.20417 2.15492L7.18346 1.16217L8.20417 2.15492L8.07496 2.28777L6.99967 3.39334ZM6.16334 11.0601L1.6551 6.42488C0.225643 4.95517 0.225643 2.57881 1.6551 1.10909C3.01628 -0.290425 5.18402 -0.365448 6.63167 0.884023C6.71367 0.954797 6.79336 1.02982 6.87046 1.10909L6.99967 1.24194L7.12889 1.10909C7.20599 1.02982 7.28568 0.954797 7.36768 0.884023C8.81533 -0.365448 10.9831 -0.290425 12.3442 1.10909C13.7737 2.57881 13.7737 4.95517 12.3442 6.42488L7.83601 11.0601C7.38677 11.522 6.64815 11.5323 6.18625 11.083C6.17472 11.0717 6.17469 11.0717 6.16342 11.0602L6.16334 11.0601ZM7.23858 10.0142L7.23857 10.0142L7.23858 10.0142Z"
                          fill="#ACB1C0"
                        />
                      </svg>
                      {product?.comment_count || 0}
                    </div>
                    <div className="mobile-men-sub-category-list-box">
                      <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10.5 4.66797C11.4665 4.66797 12.25 3.88447 12.25 2.91797C12.25 1.95147 11.4665 1.16797 10.5 1.16797C9.5335 1.16797 8.75 1.95147 8.75 2.91797C8.75 3.88447 9.5335 4.66797 10.5 4.66797Z"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M3.5 8.75C4.4665 8.75 5.25 7.9665 5.25 7C5.25 6.0335 4.4665 5.25 3.5 5.25C2.5335 5.25 1.75 6.0335 1.75 7C1.75 7.9665 2.5335 8.75 3.5 8.75Z"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M10.5 12.832C11.4665 12.832 12.25 12.0485 12.25 11.082C12.25 10.1155 11.4665 9.33203 10.5 9.33203C9.5335 9.33203 8.75 10.1155 8.75 11.082C8.75 12.0485 9.5335 12.832 10.5 12.832Z"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M5.01074 7.87891L8.99491 10.2006"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.98908 3.79688L5.01074 6.11854"
                          stroke="#ACB1C0"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {product?.sharepost_count || 0}
                    </div>
                  </div>
                </div>
                <div
                  className="listView-details_moreOption-alignment"
                  onClick={(e) => {
                    e.stopPropagation()
                    dispatch(
                      fetchMobileModalData({
                        allModalData: [
                          ...(fetchMobileModal?.allModalData ? fetchMobileModal?.allModalData : []),
                          { modal: 'productOption', isOpen: true, id: product, transform: 508 },
                        ],
                        lastModalData: fetchMobileModal?.lastModalData,
                      }),
                    )
                  }}
                >
                  <img src={MoreOptionIcon.src} alt="MoreOptionIcon" />
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </>
  )
}
